// useImageUploader.ts
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import get from "lodash/get";
import { FileUploadAPI } from "../API/fileUpload";
import NOTIFICATION_TYPE from "../AppState/NotificationType";
import { PopoutNotification } from "../AppState/popoutNotification";
import { EUploadKey, MAX_FILE_SIZE } from "../constants";
import { htmlToImage } from "../helpers";

export const useImageUploader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const uploadImage = async ({
    elementId,
    osdNumber,
    setLoading,
    navigationUrl,
    state,
    headers = {},
  }: {
    elementId: string;
    osdNumber: number;
    setLoading: (val: boolean) => void;
    navigationUrl?: string;
    state?: any;
    headers?: Record<string, string>;
  }) => {
    try {
      setLoading(true);

      const image = await htmlToImage(elementId, `1.jpeg`, MAX_FILE_SIZE);
      console.log("Use ImageUploader Generated image:", elementId, URL.createObjectURL(image));
      const reqInput = {
        osdNumber,
        docType: "FX",
        uploadKey: EUploadKey.pro,
      };

      const res = await FileUploadAPI([image], reqInput, headers);

      const errors = get(res, "errors", []);
      const notificationType =
        errors.length > 0 ? NOTIFICATION_TYPE.ERROR : NOTIFICATION_TYPE.SUCCESS;
      const message =
        errors.length > 0
          ? errors.join(", ")
          : res.result ?? "OS&D investigation image uploaded successfully";

      dispatch(
        PopoutNotification(notificationType, message, Date.now().toString())
      );

      if (navigationUrl) {
        navigate(navigationUrl, state);
      }
    } catch (error) {
      const message =
        typeof error === "string"
          ? error
          : `OS&D investigation image uploading failed`;
      dispatch(
        PopoutNotification(
          NOTIFICATION_TYPE.ERROR,
          message,
          Date.now().toString()
        )
      );
    } finally {
      setLoading(false);
    }
  };

  return { uploadImage };
};
